var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-advanced-search"}},[_c('h5',{staticClass:"m-4"},[_vm._v(_vm._s(_vm.$t('PAGES.SEARCH.ADVANCED_SEARCH')))]),_c('AdvancedSearchView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }